import { useState } from 'react';

import styled from '@emotion/styled';

import { useAppSelector } from '../../../../../../redux/store';
import VerificationForm from './VerificationForm';
import VerificationTable from './VerificationTable';

const Verification = () => {
  const { authData } = useAppSelector((state) => state.auth);
  const [editVerification, setEditVerification] = useState<'edit' | 'new'>();

  if (editVerification) {
    return (
      <Container>
        <VerificationForm
          setEditVerification={setEditVerification}
          editVerification={editVerification}
          onViewTable={() => {
            setEditVerification('edit');
          }}
        />
      </Container>
    );
  }

  return (
    <Container>
      {!authData?.verification ? (
        <VerificationForm
          onViewTable={() => {
            setEditVerification('new');
          }}
          editVerification={editVerification}
        />
      ) : (
        <VerificationTable
          setEditVerification={setEditVerification}
          // editVerification
        />
      )}
    </Container>
  );
};

export default Verification;

const Container = styled.div``;
